
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/cheat-sheet",
      function () {
        return require("private-next-pages/info/cheat-sheet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/cheat-sheet"])
      });
    }
  